<script>
//import SelectDropdown from "@/components/SelectDropdown.vue";
import StepperComponent from "@/components/Stepper.vue";
import StepFrontPage from "@/components/steps/StepFrontPage.vue";
import StepTOC from "@/components/steps/StepTOC.vue";
import StepOrgChart from "@/components/steps/StepOrgChart.vue";
import StepResume from "@/components/steps/StepResume.vue";
import StepComparable from "@/components/steps/StepComparable.vue";
import StepApproach from "@/components/steps/StepApproach.vue";
import StepLastPage from "@/components/steps/StepLastPage.vue";
import CompleteProposal from "@/components/Ctrl/CompleteProposal.vue";
import AppButton from "@/components/AppButton.vue";
import {api_baseURL} from "@/utils/init.js";
//import {completeProposals} from "@/utils/api.js";
//import {kbdpAlert} from "@/utils/util.js";
import ManagePagesModal from "@/components/ManagePagesModal.vue";
import ExtraPages from "@/components/ExtraPages.vue";
import { crossIcon, loadingLgIcon} from '@/utils/proposalIcons';
import {
  isFrontPageReady,
  isTOCReady,
  isOrgChartReady,
  isResumeReady,
  isComparableReady,
  isApproachReady,
  isLastPageReady,
  hasAtLeastOneSectionReady
} from "@/utils/proposalValidation";
import { formatedDate } from "@/utils/proposalValidation";
import { jsPDF } from "jspdf";
import {fn_computeExpectedPages,
        fn_htmlToPdfBuffer,
		fn_pdfPageCount
} from "@/utils/pdfUtils";
export default {
  name: "Home",
  components: {
    //SelectDropdown,
    StepperComponent,
    StepFrontPage,
    StepTOC,
    StepOrgChart,
    StepResume,
    StepComparable,
    StepApproach,
    StepLastPage,
    CompleteProposal,
    AppButton,
	ManagePagesModal,
	ExtraPages,
  },
  data() {
    return {
		currentStep: 1,
		currentStepType:null,
		currentStepKey:"frontPage",
		currentFileId:null,
		isComplete: false,
		proposal: {
        pageOrientation: "portrait",
        frontPage: {
          template: "",
          style: null,
          projects: [],
          name: "",
          address: "",
          city: "",
          stateProvince: "",
          submissionDate: "",
          submittedBy: "",
          logo: "",
          clientLogo: "",
          compAddress: "",
          compCity: "",
          compStateProvince: "",
          compContactNo: "",
          compEmail: "",
          compWebsite: "",
          clientName: "",
        },
        toc: {
          title: "Table Of Contents",
          template: "",
          style: null,
          itemsPerPage: 24,
          pages: [],
          projects: []
        },
        orgChart: {
          title: "Project Org Chart",
          template: "",
          style: null,
          about: {
            title: "",
            description: "",
          },
          members: [],
          projects: [],
        },
        resume: {
          title: "Team Member Resume",
          blocks: [
            {
              id: "block_1",
              template: "",
              style: null,
              projectsPerPage: 6,
              members: [],
            }
          ]
        },
        comparable: {
          title: "Comparable Projects",
          blocks: [
            {
              id: "block_1",
              template: "",
              style: null,
              about: {
                title: "",
                description: "",
              },
              projects: [],
            }
          ]
        },
        approach: {
          title: "Approach",
          blocks: [
            {
              id: "block_1",
              template: "",
              style: null,
              projects: [],
              questions: [],
            }
          ]
        },
        lastPage: {
          template: "",
          style: null,
          projects: [],
          name: "",
          logo: "",
          address: "",
          city: "",
          stateProvince: "",
          contactNo: "",
          email: "",
          submittedBy: "",
          title: "",
          location: "",
        },
        customPages: [],
        sectionOrder1: ['Front Page','Table of Contents','Org Chart', 'resume', 'comparable', 'approach','Last Page'],
		sectionOrder: ['frontPage','toc','orgChart', 'resume', 'comparable', 'approach','lastPage'],
      },
      refreshKey: 0,
      showConfirmModal: false,
      pendingOrientation: null,
      pageStartMap: {
        orgChart: 1,
        resume: 1,
        comparable: 1,
        approach: 1
      },
      steps: [
		{ number: 1, key:"frontPage", title: "Front Page", class:"kb-section-frontPage",locked: true,validate: () => isFrontPageReady(this.proposal.frontPage) },
		{ number: 2, key:"toc",title: "Table of Contents",class:"kb-section-toc", locked: true,validate: () => isTOCReady(this.proposal.toc) },
		{ number: 3, key:"orgChart",title: "Org Chart", class:"kb-section-orgChart",locked: false, validate: () => isOrgChartReady(this.proposal.orgChart)},
		{ number: 4, key:"resume",title: "Resume", class:"kb-section-resume",locked: false, validate: () => isResumeReady(this.proposal.resume) },
		{ number: 5, key:"comparable",title: "Comparable", class:"kb-section-comparable",locked: false,validate: () => isComparableReady(this.proposal.comparable)},
		{ number: 6, key:"approach",title: "Approach", class:"kb-section-approach",locked: false,validate: () => isApproachReady(this.proposal.approach) },
		{ number: 7, key:"lastPage",title: "Last Page", class:"kb-section-lastPage",locked: true, validate: () => isLastPageReady(this.proposal.lastPage) }
		],
      d_sections:[{ title: "Front Page", locked: true,validate: () => isFrontPageReady(this.proposal.frontPage) },
				{title: "Table of Contents", locked: true,validate: () => isTOCReady(this.proposal.toc) },
				{title: "Org Chart", locked: false, validate: () => isOrgChartReady(this.proposal.orgChart)},
				{title: "Resume", locked: false, validate: () => isResumeReady(this.proposal.resume) },
				{title: "Comparable", locked: false,validate: () => isComparableReady(this.proposal.comparable)},
				{title: "Approach", locked: false,validate: () => isApproachReady(this.proposal.approach) },
				{title: "Last Page", locked: true, validate: () => isLastPageReady(this.proposal.lastPage) }
      ],
      d_portrait:true,
      d_showManageModal: false,
      d_uploadingProposal: false,
      d_savingProposal: false,
      d_spinnerMessage: null,
      loadingLgIcon,
      d_isSyncingTOC:false,
    };
	
  },
  async created(){
    this.d_spinnerMessage="Uploading proposal ...";
    this.d_uploadingProposal=true;
    await this.$store.dispatch("fetchUserData");
	await this.$store.dispatch('initializeProposal', {opportunityId:this.p_recData.opportunityId});
    await this.$store.dispatch('fetchOpportunityById', this.p_recData.opportunityId);
    await this.$store.dispatch('fetchProjects', { page: 1 });
    await this.$store.dispatch('fetchMembers', { page: 1 });
    await this.$store.dispatch("fetchMarketSegments", { page: 1, limit: 999 });
	
	
	this.proposal=JSON.parse(JSON.stringify(this.$store.state.proposal));
	if(this.proposal.steps&&this.proposal.steps.length > 0) this.steps=[...this.proposal.steps];
	console.log('Created Proposal');
	console.log(this.proposal);
	
	
	const opportunity = this.$store.state.selectedOpportunity;
	const userData = this.$store.state.userData;
	this.updateProposalFromData(opportunity , userData);
	
	console.log(this.proposal);
	
	
		
	this.d_uploadingProposal=false;
	//this.syncTOC = this.m_debounce(this.syncTOC, 50);
	console.log('Created p_recData',this.p_recData);
	

	
  },
  mounted() {},
  props:{
	p_recInfo:Object,
	p_recData:Object,
  },
  computed: {
	isProposalReady() {return !!this.completeProposalId && !!this.proposal && !!this.proposal.toc; },
	completeProposalId() {return this.$store.state.completeProposalId;},
    opportunity11() {
		console.log('computed opportunity');
		console.log(this.$store.state.selectedOpportunity);
        return this.$store.state.selectedOpportunity || {};
    },
    userData() {
      return this.$store.state.userData;
    },
    canSubmit() {
      return hasAtLeastOneSectionReady(this.proposal);
    },
    sectionsReadiness() {
      return {
        orgChart: isOrgChartReady(this.proposal.orgChart),
        resume: isResumeReady(this.proposal.resume),
        comparable: isComparableReady(this.proposal.comparable),
        approach: isApproachReady(this.proposal.approach),
        orgChartTitle: this.proposal.orgChart.title,
        resumeTitle: this.proposal.resume.title,
        comparableTitle: this.proposal.comparable.title,
        approachTitle: this.proposal.approach.title,
        customPages: (this.proposal.customPages || []).map(p => ({ id: p.id, title: p.bannerTitle, position: p.position })),
        sectionOrder: [...(this.proposal.sectionOrder || [])]
      };
    },
	c_isBusy() {return this.d_uploadingProposal || this.d_savingProposal;},
    c_spinnerMessage() {return this.d_spinnerMessage || "Processing…"; },
  },
 watch: {
  // 1) Proposal changes → recompute pageStartMap (but only when ready)
  proposal: {
    handler() {
      if (!this.isProposalReady) return;

      this.$nextTick(() => {
        if (this.computeTimeout) clearTimeout(this.computeTimeout);
        this.computeTimeout = setTimeout(() => {
          this.computePageStartMap();
        }, 100);
      });
    },
    deep: true,
    immediate: false
  },

  // 2) isComplete → recompute pageStartMap once proposal is ready
  isComplete(val) {
    if (!val || !this.isProposalReady) return;

    this.$nextTick(() => {
      if (this.computeTimeout) clearTimeout(this.computeTimeout);
      this.computeTimeout = setTimeout(() => {
        this.computePageStartMap();
      }, 800);
    });
  },

  // 3) sectionsReadiness → sync TOC (only when proposal is ready)
  sectionsReadiness: {
    handler() {
	
      if (!this.isProposalReady) return;
      console.log('In sectionsReadiness watch');
      //this.syncTOC();
    },
    deep: true,
    immediate: false
  },

  // 4) pageStartMap → sync TOC (only when proposal is ready)
  pageStartMap: {
    handler() {
      if (!this.isProposalReady) return;
      console.log('In pageStartMap watch');
      //this.syncTOC();
    },
    deep: true,
    immediate: false
  },

  // 5) TOC pages → update proposal titles via Vuex (no direct mutation)
  'proposal.toc.pages': {
    handler(newPages) {
      if (!this.isProposalReady) return;
      if (!Array.isArray(newPages)) return;

      newPages.forEach(page => {
        // map sectionId → proposal path
        if (page.sectionId === 'orgChart') {
          this.$store.commit('SET_PROPOSAL_FIELD', {
            path: 'orgChart.title',
            value: page.heading
          });
        } else if (page.sectionId === 'resume') {
          this.$store.commit('SET_PROPOSAL_FIELD', {
            path: 'resume.title',
            value: page.heading
          });
        } else if (page.sectionId === 'comparable') {
          this.$store.commit('SET_PROPOSAL_FIELD', {
            path: 'comparable.title',
            value: page.heading
          });
        } else if (page.sectionId === 'approach') {
          this.$store.commit('SET_PROPOSAL_FIELD', {
            path: 'approach.title',
            value: page.heading
          });
        } else if (page.sectionId && page.sectionId.startsWith('custom_')) {
          const customId = page.sectionId.replace('custom_', '');
          this.$store.commit('SET_PROPOSAL_FIELD_FOR_CUSTOM', {
            id: customId,
            value: page.heading
          });
        }
      });
    },
    deep: true,
    immediate: false
  },

  // 6) opportunity → update proposal from data (only when both exist)
  opportunity: {
    handler(newOpp) {
      console.log('watch opportunity');
      if (!newOpp || !this.userData) return;
      this.updateProposalFromData(newOpp, this.userData);
    },
    immediate: false
  },

  // 7) userData → update proposal from data (only when both exist)
  userData: {
    handler(user) {
      if (!user || !this.p_recData) return;
      this.updateProposalFromData(this.p_recData, user);
    },
    immediate: false
  },
  steps1:{
    handler(nv){
                console.log('In steps watch');
				//this.syncTOC();
				},
	deep:true
  },
  
},
  methods: {
    m_debounce(fn, delay) {
		let timer;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => fn.apply(this, args), delay);
			};
	}, 
    handleOrientationChange(e) {
	console.log('In handleOrientationChange');
      let val;
      if(this.d_portrait) val="landscape"; else val="portrait";
      if (val === this.proposal.pageOrientation) return;
      this.pendingOrientation = val;
      this.showConfirmModal = true;
    },
    confirmOrientationChange() {
      this.d_portrait=!this.d_portrait;
      this.proposal.frontPage.template = "";
      this.proposal.toc.template = "";
      this.proposal.orgChart.template = "";
      if (this.proposal.resume.blocks) {
         this.proposal.resume.blocks.forEach(b => b.template = "");
      }
      if (this.proposal.comparable.blocks) {
        this.proposal.comparable.blocks.forEach(b => b.template = "");
      }
      if (this.proposal.approach.blocks) {
        this.proposal.approach.blocks.forEach(b => b.template = "");
      }
      this.proposal.lastPage.template = "";

      this.proposal.pageOrientation = this.pendingOrientation;
      this.refreshKey += 1;
      this.showConfirmModal = false;
      this.pendingOrientation = null;
    },
    cancelOrientationChange() {
      this.showConfirmModal = false;
      this.pendingOrientation = null;
    },
    nextStep() {
      if (this.currentStep < this.steps.length) {
        this.currentStep++;
      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    goToStep(stepNumber) {
      this.currentStep = stepNumber;
      this.currentStepType = this.steps[stepNumber-1].type||'';
      this.currentStepKey = this.steps[stepNumber-1].key||'';
      console.log('In goToStep '+stepNumber);
      console.log(`Step Type: ${this.currentStepType} Step key: ${this.currentStepKey}`);
    },
    handleEdit() {
      this.currentStep = 1;
      this.isComplete = false;
    },
    submitForm() {
      this.isComplete = true;
    },
    handleUpdateProposal(updatedProposal) {
      this.proposal = JSON.parse(JSON.stringify(updatedProposal.proposal));
      var updatedSteps = JSON.parse(JSON.stringify(updatedProposal.steps));
      this.steps = [...updatedSteps];
    },
    computePageStartMap() {
      const allSections = [
        { key: 'frontPage', class: 'kb-section-frontPage', extraPosition: 'frontPage', check: () => isFrontPageReady(this.proposal.frontPage) },
        { key: 'toc', class: 'kb-section-toc', extraPosition: 'toc', check: () => isTOCReady(this.proposal.toc) },
        { key: 'orgChart', class: 'kb-section-orgChart', extraPosition: 'orgChart', check: () => isOrgChartReady(this.proposal.orgChart) },
        { key: 'resume', class: 'kb-section-resume', extraPosition: 'resume', check: () => isResumeReady(this.proposal.resume) },
        { key: 'comparable', class: 'kb-section-comparable', extraPosition: 'comparable', check: () => isComparableReady(this.proposal.comparable) },
        { key: 'approach', class: 'kb-section-approach', extraPosition: 'approach', check: () => isApproachReady(this.proposal.approach) },
        { key: 'lastPage', class: 'kb-section-lastPage', extraPosition: 'lastPage', check: () => isLastPageReady(this.proposal.lastPage) },
      ];

      const sections = [];
      sections.push(allSections.find(s => s.key === 'frontPage'));
      sections.push(allSections.find(s => s.key === 'toc'));

      const moveableKeys = this.proposal.sectionOrder || ['orgChart', 'resume', 'comparable', 'approach'];
      moveableKeys.forEach(key => {
        const s = allSections.find(item => item.key === key);
        if (s) sections.push(s);
      });

      sections.push(allSections.find(s => s.key === 'lastPage'));

      let currentPage = 1;
      const map = {};

      for (const s of sections) {
        const isReady = s.check();
        const isCover = ['frontPage', 'toc', 'lastPage'].includes(s.key);

        if (isReady && !isCover) {
          map[s.key] = currentPage;

          const el = this.$refs.proposalContainer && this.$refs.proposalContainer.querySelector(`.${s.sectionClass}`);
          if (el) {
            const pageCount = el.querySelectorAll('.page-unit').length;
            currentPage += pageCount > 0 ? pageCount : 1;
          } else {
            currentPage += 1;
          }
        }

        if (s.key === 'frontPage') continue;
        if (s.key === 'toc') {
          const hasFPExtras = (this.proposal.customPages || []).some(f => f.position === 'frontPage');
          const showFPExtras = isFrontPageReady(this.proposal.frontPage) || isTOCReady(this.proposal.toc) || hasFPExtras;
          if (showFPExtras) {
            const fpExtras = (this.proposal.customPages && this.proposal.customPages.filter(f => f.position === 'frontPage')) || [];
            fpExtras.forEach((file, idx) => {
              map[`custom_${file.id}`] = currentPage;
              if (idx === 0) map['frontPageExtra'] = currentPage;
              currentPage += (file.isPDF && file.preview) ? file.preview.length : 1;
            });
          }
          continue;
        }

        if (isReady && s.key !== 'lastPage') {
          const customFiles = (this.proposal.customPages && this.proposal.customPages.filter(f => f.position === s.extraPosition)) || [];
          customFiles.forEach((file, idx) => {
            map[`custom_${file.id}`] = currentPage;
            if (idx === 0) map[`${s.key}Extra`] = currentPage;
            if (file.isPDF && file.preview && Array.isArray(file.preview)) {
              currentPage += file.preview.length;
            } else {
              currentPage += 1;
            }
          });
        }
      }
      this.pageStartMap = map;
    },
syncTOC1() {
  console.log("In syncTOC");

  const customPages = this.proposal.customPages || [];

  // Group custom pages by position once (prevents double filtering)
  const customByPosition = {};
  customPages.forEach(p => {
    if (!customByPosition[p.position]) customByPosition[p.position] = [];
    customByPosition[p.position].push(p);
  });

  const allSections = [];

  // 1. Custom pages that appear BEFORE the TOC
  (customByPosition["toc"] || []).forEach(p => {
    allSections.push({
      id: `custom_${p.id}`,
      name: p.bannerTitle || "Extra Page",
      check: () => true
    });
  });

  // 2. Standard sections
  const sectionMap = {
    orgChart: {
      id: "orgChart",
      name: this.proposal.orgChart.title,
      check: () => isOrgChartReady(this.proposal.orgChart)
    },
    resume: {
      id: "resume",
      name: this.proposal.resume.title,
      check: () => isResumeReady(this.proposal.resume)
    },
    comparable: {
      id: "comparable",
      name: this.proposal.comparable.title,
      check: () => isComparableReady(this.proposal.comparable)
    },
    approach: {
      id: "approach",
      name: this.proposal.approach.title,
      check: () => isApproachReady(this.proposal.approach)
    }
  };

  const order = this.proposal.sectionOrder || [
    "orgChart",
    "resume",
    "comparable",
    "approach"
  ];

  // 3. Ordered sections + custom pages after each section
  order.forEach(key => {
    if (sectionMap[key]) {
      allSections.push(sectionMap[key]);
    }

    (customByPosition[key] || []).forEach(p => {
      allSections.push({
        id: `custom_${p.id}`,
        name: p.bannerTitle || "Extra Page",
        check: () => true
      });
    });
  });

  console.log("allSections", allSections);

  // Build new TOC pages
  const currentPages = this.proposal.toc.pages;
  const newPages = [];
  let isChanged = false;

  allSections.forEach(section => {
    if (section.check()) {
      const existing = currentPages.find(p => p.sectionId === section.id);

      if (existing) {
        // Update heading if changed
        if (existing.heading !== section.name) {
          existing.heading = section.name;
          isChanged = true;
        }
        newPages.push(existing);
      } else {
        // Create new TOC entry
        newPages.push({
          id: Math.random().toString(36).substring(2, 9),
          page: "",
          heading: section.name,
          sectionId: section.id
        });
        isChanged = true;
      }
    }
  });

  if (newPages.length !== currentPages.length) {
    isChanged = true;
  }

  console.log("newPages", newPages);

  // Update page numbers
  newPages.forEach(page => {
    const startPage = this.pageStartMap[page.sectionId];
    const newPageNum =
      startPage !== undefined && !Number.isNaN(startPage)
        ? Number(startPage)
        : "??";

    if (page.page !== newPageNum) {
      page.page = newPageNum;
      isChanged = true;
    }
  });

  if (isChanged) {
    this.proposal.toc.pages = [...newPages];
  }
},
async syncTOC() {
  console.log("In syncTOC1");
  //if (this.d_isSyncingTOC) return;
  this.d_isSyncingTOC = true;

  try {
    console.log("In syncTOC2");

    const newPages = [];
    const customPages = this.proposal.customPages || [];
	const isLandscape = this.proposal.pageOrientation === 'landscape';

    const sectionMap = {
      orgChart: {
        id: "orgChart",
        name: this.proposal.orgChart.title,
        check: () => isOrgChartReady(this.proposal.orgChart)
      },
      resume: {
        id: "resume",
        name: this.proposal.resume.title,
        check: () => isResumeReady(this.proposal.resume)
      },
      comparable: {
        id: "comparable",
        name: this.proposal.comparable.title,
        check: () => isComparableReady(this.proposal.comparable)
      },
      approach: {
        id: "approach",
        name: this.proposal.approach.title,
        check: () => isApproachReady(this.proposal.approach)
      }
    };

    let totalPages = 0;

    const nonPagedSteps=["frontPage","toc","lastPage"];
	const pageSteps=this.steps.filter(s=>!nonPagedSteps.includes(s.key));
	
    for (const s of pageSteps) {
    
      let page = null;

      if (s.type === "uploadedPdf") {
        const cp = customPages.find(p => p.id == s.key);
        const pageCount = cp?.pageCount || 1;

        page = {
          id: `custom_${s.key}`,
          name: s.title || "Extra Page",
          heading: s.title || "Extra Page",
          check: () => true,
          page: totalPages + 1,
          pageCount,
          sectionId: `custom_${s.key}`
        };

        newPages.push(page);
        totalPages += pageCount;

      } else {
        const section = sectionMap[s.key];
		//if (!section) return;
		console.log(`Section class ${s.class}`);
		const el = this.$refs.proposalContainer.querySelector(`.${s.class}`);
		console.log("Section element:", el);
		//const pageCount = fn_computeExpectedPages(el, isLandscape);
		const buffer = await fn_htmlToPdfBuffer(el, {isLandscape});
		const pageCount2 = await fn_pdfPageCount(buffer);
		console.log(` ${s} pages:${pageCount2}`);
		const pageCount = s.key=='resume'?3:1;
        

        page = {
          id: section?.id||s.key,
          name: section?.name||s.title,
          heading: section?.name||s.title,
          check: section?.check||s.validate,
          page: totalPages + 1,
          pageCount: pageCount,
          sectionId: section?.id||s.key
        };

        console.log("In syncTOC3");
        newPages.push(page);
        totalPages += pageCount;
      }
    }

    console.log("newPages", newPages);

    // Prevent infinite loops
    const oldPages = this.proposal.toc.pages || [];
    if (JSON.stringify(oldPages) === JSON.stringify(newPages)) {
      return;
    }

    this.proposal.toc.pages = [...newPages];

  } finally {
    this.d_isSyncingTOC = false;
  }
},
 updateProposalFromData(newOpp, user) {
		console.log('In updateProposalFromData');
		console.log(newOpp);
      if (newOpp.opportunityName) {
	  
	    this.proposal.opportunityName=this.p_recData.opportunityName;
		this.proposal.clientAccountName=this.p_recData.clientAccount?.accountName;
		this.proposal.primaryClientAccountContactName=this.p_recData.primaryClientAccountContact?.externalContactName;
		this.proposal.internalContactName=this.p_recData.internalContact?.teamMemberName;
		
        this.proposal.toc.opprName = newOpp.opportunityName;
        this.proposal.comparable.opprName = newOpp.opportunityName;
        this.proposal.orgChart.opprName = newOpp.opportunityName;
        this.proposal.resume.opprName = newOpp.opportunityName;
        this.proposal.lastPage.name = newOpp.opportunityName;

        this.proposal.frontPage.name = newOpp.opportunityName;
        this.proposal.frontPage.address = newOpp.streetAddress;
        this.proposal.frontPage.city = newOpp.city;
        this.proposal.frontPage.stateProvince = newOpp.stateProvince;
        this.proposal.frontPage.submissionDate = formatedDate(newOpp.dueDate);

        if (user) {
          this.proposal.frontPage.logo = `${api_baseURL}${user.tenantLogoURL}`;
          this.proposal.lastPage.logo = `${api_baseURL}${user.tenantLogoURL}`;
          this.proposal.toc.logo = `${api_baseURL}${user.tenantLogoURL}`;
          this.proposal.comparable.logo = `${api_baseURL}${user.tenantLogoURL}`;
          this.proposal.orgChart.logo = `${api_baseURL}${user.tenantLogoURL}`;
          this.proposal.resume.logo = `${api_baseURL}${user.tenantLogoURL}`;

          this.proposal.toc.submittedBy = user.tenantName;
          this.proposal.resume.submittedBy = user.tenantName;
          this.proposal.orgChart.submittedBy = user.tenantName;

          this.proposal.comparable.submittedBy = user.tenantName;
          this.proposal.comparable.city = user.city;
          this.proposal.comparable.stateProvince = user.stateProvince;
          this.proposal.comparable.contactNo = user.phone;
          this.proposal.comparable.website = user.website;

          this.proposal.frontPage.submittedBy = user.tenantName;
          this.proposal.frontPage.compAddress = user.streetAddress;
          this.proposal.frontPage.compCity = user.city;
          this.proposal.frontPage.compStateProvince = user.stateProvince;
          this.proposal.frontPage.compContactNo = user.phone;
          this.proposal.frontPage.compEmail = user.email;
          this.proposal.frontPage.compWebsite = user.website;
		  this.proposal.frontPage.clientAccountName=this.p_recData.clientAccount?.accountName;
		  this.proposal.frontPage.primaryClientAccountContactName=this.p_recData.primaryClientAccountContact?.externalContactName;
		  this.proposal.frontPage.internalContactName=this.p_recData.internalContact?.teamMemberName;

          this.proposal.lastPage.submittedBy = user.tenantName;
          this.proposal.lastPage.address = user.streetAddress;
          this.proposal.lastPage.city = user.city;
          this.proposal.lastPage.stateProvince = user.stateProvince;
          this.proposal.lastPage.contactNo = user.phone;
          this.proposal.lastPage.email = user.email;
          this.proposal.lastPage.website = user.website;
        }
      }
	  console.log('proposal after updateProposalFromData'); 
	  console.log(this.proposal);
    },
	m_handleExport(type){
		this.$refs.completeProposal.handleExport(type);
	},
 async m_save() {
    this.d_spinnerMessage = "Saving proposal ...";
    this.d_savingProposal = true;
  
    const { completeProposalId, proposal } = this;
    const { opportunityId } = this.p_recData;
		

  try {
  
	
    proposal.steps = [...this.steps];
	const tempProposal = structuredClone(this.proposal);
    const dbProposal = this.m_removeFields(tempProposal, ["resumeData","photoURL"]);

    const params = {
      completeProposalId,
      opportunityId,
      proposal: JSON.stringify(dbProposal)
    };
	
	
	console.log(params);

    await this.$store.dispatch("saveProposal", params);

  } catch (err) {
    console.error("Save failed:", err);
    this.$toast?.error("Failed to save proposal");
  } finally {
    this.d_savingProposal = false;
  }
 },
  m_reorderSteps(e){
		this.steps=[...e];
		this.proposal.sectionOrder=e.map(s => s.key);
		this.proposal.steps=[...e];
	},
  m_removeFields(obj, fieldsToRemove = ['resumeData', 'photoURL']) {

  if (Array.isArray(obj)) {
    return obj.map(item => this.m_removeFields(item, fieldsToRemove));
  }

  if (obj !== null && typeof obj === "object") {
    const cleaned = {};
    for (const key in obj) {
      if (!fieldsToRemove.includes(key)) {
        cleaned[key] = this.m_removeFields(obj[key], fieldsToRemove);
      }
    }
    return cleaned;
  }

  return obj; // primitive
},

m_getStartPage(sectionId){ return this.proposal.toc.pages.filter(p=>p.id == sectionId)[0]?.page||1;}
  
}
};
</script>

<template>
  <div class="container mx-auto my-4">
  
     <div class="proposal-wrapper">
        <!-- your normal content -->
        <div v-if="c_isBusy" class="spinner-container">
           <span class="export-spinner" v-html="loadingLgIcon"></span>
           <p>{{ c_spinnerMessage }}</p>
        </div>
     </div>

  
   <!-- Unified Manage Pages Modal -->
    <ManagePagesModal :show="d_showManageModal" :proposal="proposal" :steps="steps" :sectionsReadiness="sectionsReadiness"
      @close="d_showManageModal = false" @updateProposal="handleUpdateProposal" @reorder="m_reorderSteps" />
  
    <div class="border bg-white rounded-lg subcontainer">

      <!-- Stepper Component -->
      <div class="sticky-stepper" v-if="!isComplete">

        <!-- Page Orientation Dropdown & Export Button -->
        <div class="d-flex justify-content-end align-items-end" v-if="!isComplete">
		
          <b-button v-if="d_portrait" variant="none"  class="export-btn" @click="handleOrientationChange('portrait')">
             <fa-icon icon="check" style="color:green;" />
             Portrait
          </b-button>
          <b-button v-else variant="none"  class="export-btn" @click="handleOrientationChange('landscape')">
             <fa-icon icon="check" style="color:green;" />
              Landscape		   
          </b-button>
          <b-button variant="none" :disabled="!canSubmit" class="export-btn" @click="d_showManageModal = true">
             <b-icon icon="upload" style="color: #4fa4ff;" />
             Import PDF 
          </b-button>		  
          <b-button variant="none" :disabled="!canSubmit" class="export-btn" @click="m_save">
             <fa-icon icon="save" style="color: #4fa4ff;" />
             Save 
          </b-button>  
          <b-button type="button"  variant="none"  style="border:none;" :disabled="!canSubmit" title="Preview and Export" @click="isComplete=true">
			<svg role="img" class="svg-icon" style="width: 1.5em; height: 1.5em;vertical-align: middle;fill:#4fa4ff;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<path  d="M545 793.6H243.8c-11 0-20-9-20-20V250.4c0-11 9-20 20-20h432.4c11 0 20 9 20 20v131.8c0 11 9 20 20 20s20-9 20-20V250.4c0-33.1-26.9-60-60-60H243.8c-33.1 0-60 26.9-60 60v523.2c0 33.1 26.9 60 60 60H545c11 0 20-9 20-20s-8.9-20-20-20z"/>
				<path  d="M834.6 789.8l-88.8-91.7c23.4-28.7 37.5-65.4 37.5-105.3 0-92.1-74.9-167-167-167s-167 74.9-167 167 74.9 167 167 167c37.8 0 72.7-12.6 100.7-33.9l89 91.8c3.9 4 9.1 6 14.3 6 5 0 10.1-1.9 14-5.7 7.8-7.6 8-20.3 0.3-28.2z m-218.4-69.9c-70 0-127-57-127-127s57-127 127-127 127 57 127 127-57 127-127 127zM565 382.2c0-11-9-20-20-20H308.7c-11 0-20 9-20 20s9 20 20 20H545c11.1 0 20-9 20-20zM443.5 493.5c0-11-9-20-20-20H308.7c-11 0-20 9-20 20s9 20 20 20h114.8c11.1 0 20-8.9 20-20zM308.7 584.8c-11 0-20 9-20 20s9 20 20 20h61.7c11 0 20-9 20-20s-9-20-20-20h-61.7z"/>
			</svg>
			<span>Preview</span>
          </b-button>	 
		
        </div>
        <StepperComponent :steps="steps" :current-step="currentStep" @step-click="goToStep" @prev="previousStep"
          @next="nextStep" @reorder="m_reorderSteps"/>
      </div>


	
      <div ref="proposalContainer" :key="refreshKey">
          <div v-if="!isComplete">
             <StepFrontPage v-if="currentStepKey === 'frontPage'" :proposal="proposal" />
             <StepTOC v-if="currentStepKey === 'toc'" :proposal="proposal" />
             <StepOrgChart v-if="currentStepKey === 'orgChart'" :proposal="proposal" />
             <StepResume v-if="currentStepKey === 'resume'" :proposal="proposal" />
             <StepComparable v-if="currentStepKey === 'comparable'" :proposal="proposal" />
             <StepApproach v-if="currentStepKey === 'approach'" :proposal="proposal" />
             <StepLastPage v-if="currentStepKey === 'lastPage'" :proposal="proposal" />
             <ExtraPages
               v-if="currentStepType === 'uploadedPdf'"
               :orientation="proposal.pageOrientation"
               :fileId="currentStepKey"
               :colorScheme="proposal.style && proposal.style.colorScheme"
			   :uploadedFiles="proposal.customPages" 
			   :startPage="m_getStartPage(`custom_${currentStepKey}`)"
             />
         </div>
      </div>

      <!-- Complete Proposal View -->
      <CompleteProposal v-if="isComplete" :proposal="proposal" :pageStartMap="pageStartMap" :steps="steps" @edit="handleEdit"
        @updateProposal="handleUpdateProposal" ref="completeProposal"/>

      <!-- Navigation Buttons -->
      <!-- <div v-if="!isComplete" class="d-flex justify-content-end align-items-center mt-4">
        <div class="d-flex align-items-center">
          <AppButton v-if="currentStep > 1" variant="primary" outline class="mr-2" @click="previousStep">
            Back
          </AppButton>

          <AppButton v-if="currentStep < steps.length" variant="primary" @click="nextStep">
            Next
          </AppButton>
        </div>
      </div> -->
    </div>

    <b-modal v-model="showConfirmModal" :title="'Confirm orientation change to ' + pendingOrientation" centered @hide="cancelOrientationChange"
      hide-footer>
      <p class="mb-0">If you change orientation, all selected templates will be reset. Are you sure you want to proceed?
      </p>
      <div class="d-flex justify-content-end mt-4">
        <AppButton class="mr-2" variant="danger" @click="cancelOrientationChange">Cancel</AppButton>
        <AppButton variant="success" @click="confirmOrientationChange">Confirm</AppButton>
      </div>
    </b-modal>

  </div>
</template>

<style scoped lang="scss">
.container {
  @media (min-width: 1200px) {
    max-width: 1240px !important;
  }
}

.subcontainer {
  padding: 24px;

  @media screen and (max-width: 990px) {
    padding: 12px;
  }
}
.scroll-area {
  overflow-y: auto;
  height: calc(100vh - 140px); /* adjust based on header height */
  padding-right: 4px; /* prevents scrollbar overlap */
}

.sticky-stepper {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
}
.proposal-content {
  overflow: visible !important;
}
.orientation-dropdown {
  width: 134px;
}

.export-btn {
  height: 25px;
  display: flex;
  align-items: center;
  margin-right: 5px;
  border:none;
}
.export-icon {
  color: #4fa4ff !important;
}
.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
}
/* Make dropdown items look like links */
.dropdown-menu .dropdown-item {
  color: #4fa4ff !important;      /* Bootstrap link blue */
  background: transparent !important;
  text-decoration: none;
  padding: 6px 14px;
}

/* Hover: underline + subtle background */
.dropdown-menu .dropdown-item:hover {
  text-decoration: underline;
  background: rgba(0, 0, 0, 0.03) !important;
  color: #0056b3 !important;      /* darker blue on hover */
}
.canva-icon {
  width: 20px;
  height: 10px;
  vertical-align: middle;
  margin-right: 6px;
  border:none;
}
.export-trigger {
  display: flex !important;
  align-items: center;
  gap: 6px;
  padding: 6px 12px !important;
  border: 1px solid #d0d7e2 !important;
  border-radius: 6px !important;
  background: white !important;
  color: #4fa4ff !important;
  font-weight: 500;
}

.export-trigger:hover {
  background: #f4f8ff !important;
  border-color: #4fa4ff !important;
}
.export-menu {
  padding: 6px 0;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.08);
  background: white;
}
.export-item {
  width: 100%;
  display: flex !important;
  align-items: center;
  gap: 10px;
  padding: 8px 14px !important;
  text-align: left;
  color: #2c3e50 !important;
  text-decoration: none !important;
}

.export-item span {
  font-size: 14px;
}

.export-icon-item {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.export-icon-item.pdf { color: #e63946; }
.export-icon-item.word { color: #4fa4ff; }
.export-icon-item.canva { border-radius: 4px; }
.export-item:hover {
  background: #f4f8ff !important;
  color: #4fa4ff !important;
  text-decoration: underline !important;
}
.spinner-container1 {
        text-align: center;

        .export-spinner {
            display: inline-block;
            animation: spin 1s linear infinite;
            color: #4475b4;
        }

        p {
            color: #4475b4;
            font-weight: 700;
            font-size: 14px;
            margin: 0;
        }

  }
.spinner-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.6); /* optional dimming */
  z-index: 9999; /* make sure it's above everything */
 .export-spinner {
    display: inline-block;
    animation: spin 1s linear infinite;
    color: #4475b4;
    }
	p {
       color: #4475b4;
       font-weight: 700;
       font-size: 14px;
       margin: 0;
     }
}
.proposal-wrapper {
  position: relative;
} 
</style>